import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackShareWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackShareWishList";

const useTrackShareWishList = (
    parameters: TrackShareWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.shareWishList, parameters, options);
};

export default useTrackShareWishList;
